// 회사소개 사이드바/드롭다운 공용 메뉴 (모든 회사소개 페이지에서 공유)
export const aboutMenus = [
  { label: '인사말', path: '/about' },
  { label: '연혁', path: '/about/history' },
  // 조직도 임시 숨김: 아래 줄 주석을 해제하면 메뉴에 다시 노출됨 (페이지/라우트는 그대로 유지)
  // { label: '조직도', path: '/about/organization' },
  { label: '오시는길', path: '/about/location' },
  { label: '보유인증현황', path: '/about/certifications' },
];
